export default __webpack_public_path__ + "static/media/delBst.7fc7d0c1.jpg";